import { useMemo } from 'react';
import { columnWidths } from '../utilities';
export var useTableColumnWidths = function useTableColumnWidths(columns) {
  return useMemo(function () {
    return columnWidths(columns);
  }, [columns]);
};